import React from 'react';
import { motion } from 'framer-motion';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="bg-background px-4 pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-180" data-mp="9k0fvb7hqlr8">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-181" data-mp="4lyw0o28qiep">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-182" data-mp="4jvup7vn12uo">
          <p className="font-display text-xl font-semibold text-foreground sm:text-2xl" data-id="element-183" data-mp="xbpaiy7sbmbc">
            <ProductName script data-id="element-184" data-mp="sa9szg4tfxxp" />
          </p>
          <h1 className="mx-auto mt-3 max-w-4xl text-3xl font-semibold leading-[1.1] text-foreground sm:text-5xl" data-id="element-185" data-mp="sd4cn5g09eq2">
            Solve Months of Stretching Class Planning in Just{' '}
            <span className="italic text-primary" data-id="element-186" data-mp="3d2tln1u126au">5 Minutes</span>
          </h1>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease
      }} src="https://cdn.magicpatterns.com/uploads/ssAy3Efh7Zu57pbYmGZUwd/Diseno_sin_titulo_(67).png" alt="Stretching Instructor Ready: 6-volume box set, Class Finder tablet and the 5 bonus guides" className="mx-auto mt-5 w-full max-w-3xl drop-shadow-xl sm:mt-6" data-id="element-187" data-mp="384jssxvrzhse" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease
      }} className="mt-5 flex flex-col items-center sm:mt-6" data-id="element-188" data-mp="30h9blrt8e1mr">
          <p className="mx-auto max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg" data-id="element-189" data-mp="2qhqwboo9n411">
            A complete <span className="font-semibold text-primary" data-id="element-190" data-mp="2vglkl6505ksj">6-in-1</span>{' '}
            visual teaching system with 150 ready-to-teach stretching classes,
            6 complete volumes, and 5 professional bonus guides — 100% visual,
            ready to open and use.
          </p>
          <div className="mt-6" data-id="element-191" data-mp="s3coeiao1xu9">
            <CheckoutButton data-id="element-192" data-mp="nbl2wm6daiaz">GET STRETCHING INSTRUCTOR READY NOW</CheckoutButton>
          </div>
        </motion.div>
      </div>
    </section>;
}